<template>
  <custom-dialog width="450px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form :model="form" ref="form" :rules="rules" :validate-on-rule-change="false">
        <el-form-item :label="$t('device_rename_dialog.she_bei_ming_cheng')" prop="deviceName">
          <el-input v-model="form.deviceName"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="warning" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        deviceName: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        deviceName: {
          required: true,
          message: this.$t('device_rename_dialog.qsrsbmc'),
        },
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      if (this.model.type === 'edit') {
        const row = this.model.data;
        this.$setFormatData(this.form, row);
      }
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$postJSON(apis.portalDeviceUpdateDeviceName, {
          deviceId: this.model.data.deviceId,
          deviceName: this.form.deviceName
        }).then(() => {
          this.$message({
            message: this.$t('Common.com_add_success'),
            type: 'success',
          });
          this.visible = false;
          this.$emit('success', this.form);
        });
      });
    },
  },
};
</script>

<style lang="scss"></style>
